module.exports = __webpack_public_path__ + "img/update-blocked.6797c8f2.svg";